// extracted by mini-css-extract-plugin
export var displayNone = "_rc-6";
export var imgContainer = "_rc-2";
export var overflowHidden = "_rc-3";
export var productInfoCardButtonContainer = "_rc-5";
export var productTitleText = "_rc-4";
export var rightArrow = "_rc-1";
export var rightArrowContainer = "_rc-0";